import { useTranslation } from 'react-i18next';
import * as ReactSlick from 'react-slick';
const Slider = ReactSlick.default;
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const CustomArrow = ({ direction, onClick }: { direction: 'prev' | 'next', onClick?: () => void }) => {
  const isNext = direction === 'next';
  return (
    <button
      onClick={onClick}
      className={`hero-arrow ${isNext ? 'right-8' : 'left-8'}`}
      aria-label={isNext ? 'Next slide' : 'Previous slide'}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24" 
        strokeWidth={2} 
        stroke="currentColor" 
        className="w-8 h-8"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          d={isNext ? "M8.25 4.5l7.5 7.5-7.5 7.5" : "M15.75 19.5L8.25 12l7.5-7.5"} 
        />
      </svg>
    </button>
  );
};

export default function HeroSlider() {
  const { t } = useTranslation();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: <CustomArrow direction="prev" />,
    nextArrow: <CustomArrow direction="next" />,
  };

  const slides = [
    {
      key: 'slide1',
      bgImage: '/images/temp/slide1.jpg',
    },
    {
      key: 'slide2',
      bgImage: '/images/temp/slide3.jpg',
    },
    {
      key: 'slide3',
      bgImage: '/images/temp/slide2.jpg',
    },
  ];

  return (
    <div className="relative bg-gray-900 h-screen">
      <Slider {...settings}>
        {slides.map((slide) => (
          <div key={slide.key} className="relative h-screen">
            <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${slide.bgImage})` }}
            >
              <div className="absolute inset-0 bg-black opacity-50" />
            </div>
            <div className="relative h-full flex items-center justify-center text-center text-white px-4">
              <div className="max-w-3xl">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
                  {t('hero.title')}
                </h1>
                <p className="text-xl md:text-2xl mb-8">
                  {t('hero.subtitle')}
                </p>
                <a
                  href="#contact"
                  className="inline-block bg-[#ff5f00] text-white py-3 px-8 rounded-lg text-lg font-semibold hover:bg-[#e65600] transition-all hover:scale-105"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {t('hero.cta')}
                </a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
